<template>
  <div class="px-4 pb-4 mt-4">
    <div class=" sm:px-6 lg:px-8 card">
      <div class="flow-root ">
        <div class="-mx-2 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="card-header">
            <h3 class="px-4 mb-0 text-lg" style="text-transform: capitalize">
              Accept payments
            </h3>
          </div>

          <div class="px-4 pt-2 sm:flex sm:items-center sm:space-x-10">
            <base-input label="Search Customer By">
              <el-radio-group v-model="filterBy">
                <el-radio label="name">
                  Name
                </el-radio>
                <el-radio label="phone">
                  Phone
                </el-radio>
                <el-radio label="serviceRequestNumber">
                  Service Request Number
                </el-radio>
              </el-radio-group>
            </base-input>
          </div>

          <div class="px-4 mb-4">
            <div class="flex items-center gap-6">
              <div class="flex flex-col" v-if="filterBy === 'name'">
                <label class="text-sm font-medium"
                  >Search Customer By Name</label
                >
                <el-select
                  clearable
                  ref="customerInput"
                  v-model="userId"
                  filterable
                  remote
                  :remote-method="filterUserByName"
                  :loading="loading"
                >
                  <div v-if="filteredUsers.length > 0">
                    <el-option
                      v-for="(item, index) in filteredUsers"
                      :key="index"
                      :value="item.userId"
                      :label="
                        item.firstName +
                          ' ' +
                          item.lastName +
                          ' (' +
                          item.phone +
                          ')'
                      "
                    />
                  </div>
                </el-select>

                <div v-if="this.error" class="mt-1 text-red-600">
                  {{ this.error }}
                </div>
              </div>
              <div v-if="filterBy === 'phone'">
                <label class="text-sm font-medium"
                  >Search Customer By Phone</label
                >
                <input
                  type="text"
                  v-model="phone"
                  class="w-full p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-200 focus:outline-none"
                  placeholder="Enter phone"
                />
                <div v-if="this.error" class="mt-1 text-red-600">
                  {{ this.error }}
                </div>
              </div>
              <div v-if="filterBy === 'serviceRequestNumber'">
                <label class="text-sm font-medium"
                  >Customer By Service Request Number</label
                >
                <input
                  type="text"
                  v-model="serviceRequestNumber"
                  class="w-full p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-200 focus:outline-none"
                  placeholder="Enter service request number"
                />
                <div v-if="this.error" class="mt-1 text-red-600">
                  {{ this.error }}
                </div>
              </div>
              <div class="justify-center pt-4 align-middle">
                <button
                  @click="searchRecords()"
                  type="submit"
                  size="sm"
                  class="px-2 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700"
                >
                  Search
                </button>
              </div>
              <div v-if="users && users.length > 1">
                <base-input label="Select Customer" tabindex="0">
                  <el-select
                    v-model="selectedUser"
                    filterable
                    @change="handleUserSelect"
                  >
                    <div v-if="users && users.length > 0">
                      <el-option
                        v-for="(item, index) in users"
                        :key="index"
                        :value="item"
                        :label="item"
                        isSearched
                      />
                    </div>
                  </el-select>
                </base-input>
              </div>
            </div>
            <div v-if="this.serverError" class="pb-4 text-red-600">
              {{ this.serverError }}
            </div>
          </div>
          <div v-if="list.length > 0 && selectedUser" class="mt-3 border-t">
            <h3 class="px-4 py-1 text-lg font-medium">Search Results</h3>
            <div class="flex gap-4 px-4 py-2">
              <div>
                <span class="text-base font-medium">User Name : </span
                ><span class="px-1 text-lg font-bold capitalize">{{
                  selectedUser
                }}</span>
              </div>
              <div>
                <span class="text-base font-medium">Total : </span
                ><span class="px-1 text-lg font-bold capitalize">{{
                  total | currency
                }}</span>
              </div>
              <div>
                <span class="text-base font-medium"
                  >Total of Selected Records : </span
                ><span class="px-1 text-lg font-bold capitalize">
                  {{ selectedRecordsTotal | currency }}
                </span>
              </div>

              <div class="flex">
                <span class="pr-2 text-base font-medium">Amount Paying: </span
                ><input
                  type="text"
                  v-model="amountPaying"
                  @input="filterOutstandingRecords"
                  class="px-1 border border-gray-300 rounded-md focus:ring focus:ring-blue-200 focus:outline-none"
                  placeholder="Enter paying amount"
                />
              </div>
              <div class="flex">
                <span class="pr-2 text-base font-medium">Discount: </span
                ><input
                  type="text"
                  v-model="bulkDiscount"
                  @input="handleDiscountChange"
                  class="px-1 border border-gray-300 rounded-md focus:ring focus:ring-blue-200 focus:outline-none"
                  placeholder="Enter discount"
                />
              </div>
              <div v-if="selectedRecords.length > 0">
                <base-button
                  size="sm"
                  type="primary"
                  @click="validateAndConfirm()"
                  >Validate & Confirm</base-button
                >
              </div>
            </div>
            <div
              v-if="selectedRecords.length > 0 && showPaymentDetails"
              class="flex gap-6 px-4 py-2"
            >
              <div class="flex">
                <span class="pr-2 text-base font-medium">Payment Mode: </span>
                <div class="grid grid-cols-1 -mt-1">
                  <select
                    v-model="paymentModeId"
                    id="paymentMode"
                    name="paymentMode"
                    class="col-start-1 row-start-1 w-40 border appearance-none rounded-md bg-white py-0.5 pl-3 pr-4 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  >
                    <option
                      v-for="(item, index) in paymentModes"
                      :key="index"
                      :value="item.paymentModeId"
                      >{{ item.label }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="flex">
                <span class="pr-2 text-base font-medium">Payment Note: </span
                ><input
                  type="text"
                  v-model="paymentNote"
                  class="px-1 border border-gray-300 rounded-md focus:ring focus:ring-blue-200 focus:outline-none"
                  placeholder="Enter payment note"
                />
              </div>
              <base-button
                size="sm"
                type="primary"
                @click="handleAcceptBulkPayment()"
                >Submit</base-button
              >
              <span class="text-sm text-red-400"
                >* Before submitting records, please validate and confirm
                first.</span
              >
            </div>
            <div v-if="submissionErrors" class="px-4 pb-4 text-red-600">
              {{ submissionErrors }}
            </div>
            <div style="height:calc(100vh - 380px)" class="overflow-y-scroll">
              <table
                class="w-full px-4 text-left border border-collapse border-gray-200 "
              >
                <thead class="bg-gray-200">
                  <tr>
                    <th class="px-3 py-2 border border-gray-300">
                      <input
                        type="checkbox"
                        :checked="isAllSelected"
                        @change="toggleSelectAll"
                      />
                    </th>
                    <th class="px-3 py-2 border border-gray-300">Date</th>
                    <th class="px-3 py-2 border border-gray-300">
                      Sale Inv. No.
                    </th>
                    <th class="px-3 py-2 border border-gray-300">
                      Service Req. No.
                    </th>

                    <th class="px-3 py-2 border border-gray-300">
                      Labor Total
                    </th>
                    <th class="px-3 py-2 border border-gray-300">
                      Ext. Goods
                    </th>
                    <th class="px-3 py-2 border border-gray-300">
                      Total
                    </th>
                    <th class="px-3 py-2 border border-gray-300">
                      Paid
                    </th>
                    <th class="px-3 py-2 border border-gray-300">
                      Discount
                    </th>

                    <th class="px-3 py-2 border border-gray-300">
                      Pending
                    </th>
                    <th class="px-3 py-2 border border-gray-300"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record, index) in list"
                    :key="index"
                    class="hover:bg-gray-100"
                    :class="
                      record.partially_covered === false
                        ? 'bg-green-100'
                        : record.partially_covered === true
                        ? 'bg-yellow-100'
                        : 'bg-white'
                    "
                  >
                    <td class="px-3 py-2 border border-gray-300">
                      <input
                        type="checkbox"
                        :checked="selectedRecords.includes(index)"
                        @change="toggleCheckbox(index)"
                      />
                    </td>
                    <td class="px-3 py-2 border border-gray-300">
                      {{ record.date }}
                    </td>
                    <td class="px-3 py-2 border border-gray-300">
                      {{ record.invoice_number }}
                    </td>
                    <td class="px-3 py-2 border border-gray-300">
                      {{ record.service_request_number }}
                      <template>
                        <span class="badge assign-status">{{
                          record.vendor
                        }}</span>
                      </template>
                    </td>

                    <td class="px-3 py-2 border border-gray-300">
                      {{ record.labor_total | currency }}
                    </td>
                    <td class="px-3 py-2 border border-gray-300">
                      {{ record.external_goods_total | currency }}
                    </td>
                    <td class="px-3 py-2 border border-gray-300">
                      {{ record.total_amount | currency }}
                    </td>
                    <td class="px-3 py-2 border border-gray-300">
                      {{ record.amount_paid | currency }}
                    </td>
                    <td class="px-2 py-2 border border-gray-300">
                      <input
                        type="text"
                        v-model="record.discount"
                        @input="handleInlineDiscountChange(record, index)"
                        class="w-32 px-1 border border-gray-300 rounded-md focus:ring focus:ring-blue-200 focus:outline-none"
                        placeholder="Enter discount"
                      />
                      <span
                        v-if="record.partially_covered"
                        class="inline-flex items-center px-2 py-1 text-xs font-medium text-yellow-800 rounded-md bg-yellow-50 ring-1 ring-inset ring-yellow-600/20"
                      >
                        Partially covered
                      </span>
                    </td>
                    <td
                      v-if="record.discount > 0"
                      class="px-3 py-2 border border-gray-300"
                    >
                      {{ record.updated_outstanding_amount | currency }}
                    </td>
                    <td v-else class="px-3 py-2 border border-gray-300">
                      {{ record.outstanding_amount | currency }}
                    </td>
                    <td class="px-3 py-2 border border-gray-300">
                      <base-button
                        size="sm"
                        type="primary"
                        @click="handleAcceptPayment(record)"
                        >Accept Payment</base-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            v-else-if="isSearched && users.length === 0"
            class="py-3 mt-6 text-center text-red-600"
          >
            No records found for the entered data.
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showAcceptPaymentModal" title="Add Payment">
      <add-advance
        :service-request-id="selectedServiceRequestId"
        @close="handleClosePaymentModal()"
      />
    </el-dialog>
    <el-dialog
      :visible.sync="showSaleTransactionModal"
      title="Show Transaction"
    >
      <show-transaction @close="showSaleTransactionModal = false" />
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../components/Pagination.vue";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import AddAdvance from "../ServiceRequest/AddAdvance.vue";
import { Dialog, RadioGroup, Radio, Select, Option } from "element-ui";
import { mapActions, mapGetters } from "vuex/dist/vuex.common.js";
import ShowTransaction from "../Pos/ShowTransaction.vue";
export default {
  data() {
    return {
      userId: "",
      phone: "",
      serviceRequestNumber: "",
      perPage: 10,
      perPageOptions: [5, 10, 25, 50],
      paginationLinks: [],
      list: [],
      isSearched: false,
      error: null,
      serverError: null,
      showAcceptPaymentModal: false,
      showSaleTransactionModal: false,
      selectedServiceRequestId: null,
      filterBy: "name",
      users: [],
      selectedUser: null,
      selectedRecords: [],
      result: [],
      bulkDiscount: 0,
      amountPaying: 0,
      showPaymentDetails: false,
      paymentModeId: null,
      paymentNote: "",
      submissionErrors: null,
      isValidated: false,
      filteredUsers: [],
      loading: false
    };
  },
  components: {
    Pagination,
    "add-advance": AddAdvance,
    "show-transaction": ShowTransaction,
    [Dialog.name]: Dialog,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Select.name]: Select,
    [Option.name]: Option
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    }
  },
  computed: {
    ...mapGetters({ paymentModes: "paymentMode/getPaymentModes" }),

    isAllSelected() {
      return (
        this.list.length > 0 && this.list.length === this.selectedRecords.length
      );
    },
    total() {
      if (this.list.length > 0) {
        const sum = this.list.reduce(
          (a, b) => a + parseFloat(b.outstanding_amount),
          0
        );
        return sum;
      }
    },
    selectedRecordsTotal() {
      const totalAmounts = this.selectedRecords.map(
        index => this.list[index].outstanding_amount
      );
      const sum = totalAmounts.reduce((a, b) => a + parseFloat(b), 0);

      return sum;
    }
  },
  mounted() {
    this.getPaymentModes();
  },

  methods: {
    ...mapActions({
      getSaleTransactions: "sale/getSaleTransactions",
      editSale: "sale/editSale",
      getPaymentModes: "paymentMode/getPaymentModes",
      acceptBulkPayment: "paymentMode/acceptBulkPayment",
      searchUsers: "user/searchUsers"
    }),

    refreshPage() {
      this.userId = "";
      this.phone = "";
      this.serviceRequestNumber = "";
      this.users = [];
      this.amountPaying = 0;
      this.paymentModeId = "";
      this.paymentNote = "";
      this.bulkDiscount = 0;
      this.result = [];
      this.selectedRecords = [];
      this.selectedUser = null;
      this.filteredUsers = [];
    },

    validateForm() {
      this.error = null;
      this.serverError = null;
      if (
        this.phone === "" &&
        this.serviceRequestNumber === "" &&
        this.userId === ""
      ) {
        this.error =
          "Please enter atleast name or phone or service request number.";
      }
    },

    searchRecords() {
      this.validateForm();
      if (this.error === null) {
        this.list = [];
        this.selectedUser = "";
        this.isSearched = true;

        let query = {};
        if (this.filterBy === "phone") {
          query = `phone=${this.phone}`;
        } else if (this.filterBy === "serviceRequestNumber") {
          query = `service_request_number=${this.serviceRequestNumber}`;
        } else if (this.filterBy === "name") {
          query = `user_id=${this.userId}`;
        }
        apiHelper
          .call(
            "get",
            `${endpoints.LARAVEL_BASE_URL}/api/v1/pending/payments?${query}`
          )
          .then(response => {
            if (response.data.length > 1) {
              this.users = response.data.map(item => item.user);
            } else {
              this.selectedUser = response.data[0].user;
              this.list = response.data[0].records;
            }
            this.result = response.data;
          })
          .catch(err => {
            if (
              err &&
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.serverError = err.response.data.message;
            }
          });
      }
    },

    handleAcceptPayment(record) {
      if (record.service_request_id) {
        this.showAcceptPaymentModal = true;
        this.selectedServiceRequestId = record.service_request_id;
      }
      if (record.sale_id) {
        this.editSale(record.sale_id);
        this.getSaleTransactions(record.sale_id);
        this.showSaleTransactionModal = true;
      }
    },

    validateAndConfirm() {
      this.filterOutstandingRecords();
      this.showPaymentDetails = true;
      this.isValidated = true;
    },

    validateSubmission() {
      this.submissionErrors = null;
      if (this.paymentModeId === "" || this.paymentModeId === null) {
        this.submissionErrors = "Please select atleast one payment mode";
      }
    },

    handleAcceptBulkPayment() {
      this.submissionErrors = null;
      this.validateSubmission();
      if (this.isValidated === true) {
        if (this.submissionErrors === null) {
          const filteredRecords = this.selectedRecords.map(
            index => this.list[index]
          );
          apiHelper
            .call(
              "post",
              `${endpoints.LARAVEL_BASE_URL}/api/v1/accept/pending/payments`,
              {
                records: filteredRecords,
                paymentModeId: this.paymentModeId,
                paymentNote: this.paymentNote,
                paying: this.amountPaying
              }
            )
            .then(() => {
              this.refreshPage();
              this.$notify({
                message: "Payment Accepted Succesfully!",
                type: "success",
                title: "Success"
              });
            })
            .catch(() => {
              this.$notify({
                message: "Something Went Wrong!",
                type: "danger",
                title: "error"
              });
            });
        } else {
          console.log("in error");
        }
      } else {
        this.$notify({
          message: "Please validate and confirm selected records!",
          type: "danger",
          title: "error"
        });
      }
    },

    handleClosePaymentModal() {
      this.showAcceptPaymentModal = false;
      this.selectedServiceRequestId = null;
    },
    handleUserSelect() {
      const [data] = this.result.filter(
        item => item.user === this.selectedUser
      );
      this.list = data.records;
    },
    toggleCheckbox(index) {
      if (this.selectedRecords.includes(index)) {
        this.selectedRecords = this.selectedRecords.filter(
          (key, value) => key !== index
        );
        this.list[index].discount = 0;
        this.list[index].partially_covered = null;
        this.handleDiscountChange();
      } else {
        this.selectedRecords.push(index);
        this.handleDiscountChange();
      }
      this.amountPaying = this.selectedRecordsTotal - this.bulkDiscount;
      this.isValidated = false;
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedRecords = [];
        this.list = this.list.map(item => {
          return { ...item, discount: 0, partially_covered: null };
        });
      } else {
        this.selectedRecords = this.list.map((item, index) => index);
        this.handleDiscountChange();
      }
      this.amountPaying = this.selectedRecordsTotal - this.bulkDiscount;
      this.isValidated = false;
    },
    handleDiscountChange() {
      const discountValue = parseFloat(this.bulkDiscount);
      if (isNaN(discountValue)) {
        return;
      } else {
        if (this.selectedRecords.length > 0) {
          const serviceRequestRecords = this.selectedRecords.filter(
            index => !this.list[index].sale_id
          );
          const discount = parseFloat(
            discountValue / serviceRequestRecords.length
          ).toFixed(2);
          serviceRequestRecords.forEach(item => {
            this.list[item].discount = discount;
            this.list[item].updated_outstanding_amount = parseFloat(
              (this.list[item].outstanding_amount - discount).toFixed(2)
            );
          });
        }
      }
    },
    handleInlineDiscountChange(record, key) {
      this.list = this.list.map((item, index) => {
        if (index === key) {
          return {
            ...item,
            updated_outstanding_amount:
              record.outstanding_amount - record.discount
          };
        }
        return item;
      });
    },
    filterOutstandingRecords() {
      let remainingAmount = parseFloat(this.amountPaying) || 0;
      this.recordList = [];
      this.selectedRecords = [];
      this.list = this.list.map(item => {
        return { ...item, partially_covered: null };
      });
      for (let i = 0; i < this.list.length; i++) {
        const record = this.list[i]; // Access the record
        record.partially_covered = null;
        const amount =
          record.discount > 0
            ? record.updated_outstanding_amount
            : record.outstanding_amount;
        if (remainingAmount <= 0) break;
        if (remainingAmount >= amount) {
          // Fully covers this record
          this.selectedRecords.push(i); // Push the index
          record.partially_covered = false;
          remainingAmount = parseFloat((remainingAmount - amount).toFixed(2));
        } else if (remainingAmount > 1) {
          record.partially_covered = true;
          remainingAmount = 0;
          this.selectedRecords.push(i); // Push the index
          break; // Stop further selection as the amount is fully consumed
        }
      }
    },
    filterUserByName(query) {
      this.searchedQuery = query;
      if (query !== "") {
        this.loading = true;
        this.searchUsers({ name: query })
          .then(res => {
            this.filteredUsers = res;
            this.loading = false;
          })
          .catch(err => {
            if (err.status === 422) {
              this.filteredUsers = [];
            }
          });
      } else {
        this.options = [];
      }
    }
  }
};
</script>
<style>
.assign-status {
  background-color: #60c8be;
  border-color: #60c8be;
  color: #fff;
}
</style>
